/**
 * @author frank.zhang
 * 2022-06-29
 */
class AccessoriesSales extends HTMLElement {
  constructor() {
    super();

    this.selectedAccessories = [];
    this.selectedProductIds = [];
    this.lastFetchTask = null;

    // mount this to container
    const targetContainer = document.querySelector('div#' + this.dataset.targetContainerId);
    if (targetContainer) {
      targetContainer.innerHTML = '';
      targetContainer.appendChild(this);
    }

    // 根据URL携带参数默认勾选配件
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('selectAccessories') === '1') {
      const accessories = urlParams.get('accessories').split('|||');
      for (const accessory of accessories) {
        const [productId, productHandle, variantId, price] = accessory.split('___');
        this.selectItem(+productId, productHandle, +variantId, +price, '');
      }
    }
  }

  selectItem(productId, productHandle, variantId, price, sku) {
    if (!this.selectedProductIds.includes(Number(productId))) {
      this.selectedAccessories.push({
        productId,
        productHandle,
        variantId,
        price,
        sku
      });
      this.selectedProductIds = this.selectedAccessories.map((d) => d.productId);
      this.refreshListView();
    }
  }

  removeItem(productId) {
    if (this.selectedProductIds.includes(Number(productId))) {
      this.selectedAccessories = this.selectedAccessories.filter((d) => d.productId !== Number(productId));
      this.selectedProductIds = this.selectedAccessories.map((d) => d.productId);
      this.refreshListView();
    }
  }

  refreshListView() {
    const listItems = this.querySelectorAll('.accessories-list li[data-type=accessory]');
    listItems.forEach((el) => {
      const { productId } = el.dataset;
      if (this.selectedProductIds.includes(Number(productId))) {
        el.classList.add('selected');
      } else {
        el.classList.remove('selected');
      }
    });

    // 展示全部配件按钮上的已选按钮计数
    const selectedCountElement = this.querySelector('.selectedCount');
    const buttonTextElement = this.querySelector('.button_text');
    const buttonTextAfterSelectedElement = this.querySelector('.button_text_after_selected');
    if (selectedCountElement) {
      if (this.selectedAccessories.length) {
        selectedCountElement.classList.remove('hidden');
        buttonTextAfterSelectedElement.classList.remove('hidden');
        buttonTextElement.classList.add('hidden');
        selectedCountElement.querySelector('.selectedCountNum').innerHTML = this.selectedAccessories.length;
      } else {
        selectedCountElement.classList.add('hidden');
        buttonTextAfterSelectedElement.classList.add('hidden');
        buttonTextElement.classList.remove('hidden');
        selectedCountElement.querySelector('.selectedCountNum').innerHTML = 0;
      }
    }

    // 选择或取消选择配件时更新产品信息区价格
    const outsideVariantElement = document.querySelector('variant-radios:not([data-tplsuffix="accessory-modal"])');
    const { price, compare_at_price } = outsideVariantElement.currentVariant;
    const accessoriesTotalPrice = this.selectedAccessories.reduce((prev, curr) => prev + Number(curr.price), 0);
    const comparePrice = compare_at_price
      ? theme.Currency.formatMoney(compare_at_price + accessoriesTotalPrice * 100, shopSettings.moneyFormat)
      : null;
    outsideVariantElement.updatePrice(
      theme.Currency.formatMoney(price + accessoriesTotalPrice * 100, shopSettings.moneyFormat),
      true,
      comparePrice
    );

    const addCartButtonPriceElement = document.querySelector('.product-form__buttons.outside .totalPriceWithAccessories');
    if (accessoriesTotalPrice > 0) {
      addCartButtonPriceElement.innerHTML = `(${theme.Currency.formatMoney(
        price + accessoriesTotalPrice * 100,
        shopSettings.moneyFormat
      )})`;
    } else {
      addCartButtonPriceElement.innerHTML = '';
    }

    window.UniEventBus.submit('UPDATE_SELECTED_ACCESSORIES', this.selectedAccessories);
  }

  connectedCallback() {
    // init variables
    this.modal = this.querySelector('modal-dialog');
    this.contentNode = this.querySelector('.product-content .html-content');
    this.loadingBar = this.querySelector('.loading-bar');
    const self = this;

    this.observerModal();

    // click add button
    EventDelegationUtil.on(this, 'click', 'li[data-type=accessory] .add-button', function (e) {
      if (this.classList.contains('unfit')) {
        return;
      }
      const { productHandle, productId, productVariantCount, firstVariantId, firstVariantPrice, firstVariantSku } = this.dataset;
      if (productVariantCount == 1) {
        self.selectItem(+productId, productHandle, firstVariantId, firstVariantPrice, firstVariantSku);
      } else {
        // 如果点击的是打开的弹窗中的add-button，那就给底部的select按钮加点动画效果提示用户需要点击下方的select按钮，而不是点击侧边的add按钮
        self.querySelector('.select-item-button')?.classList.add('flicker');
        setTimeout(() => {
          self.querySelector('.select-item-button')?.classList.remove('flicker');
        }, 500);
      }
      this.parentNode.click();
    });

    // click selected button
    EventDelegationUtil.on(this, 'click', 'li[data-type=accessory] .selected-button', function (e) {
      const { productHandle, productId } = this.dataset;
      self.removeItem(productId);
    });

    // click open modal button
    EventDelegationUtil.on(this, 'click', 'button.open-modal-button', function (e) {
      self.querySelector('.outer-list-container li[data-type=accessory]').click();
    });

    // click close modal button
    EventDelegationUtil.on(this, 'click', 'button#accessories-closeTest', function (e) {
      self.modal.click();
    });

    // click accessory item
    EventDelegationUtil.on(
      this,
      'click',
      'li[data-type=accessory], li[data-type=gift], li[data-type=gift_with_product]',
      function (e) {
        if (this.classList.contains('checked') || this.classList.contains('unfit')) {
          return;
        }
        let inModal = false;
        let curNode = this.parentNode;
        while (curNode != self.modal.parentNode) {
          if (curNode.matches('modal-dialog')) {
            inModal = true;
            break;
          }
          curNode = curNode.parentNode;
        }

        const { type } = this.dataset;
        const oneline = this.hasAttribute('oneline');

        let accessoryElement = this;
        /**
         * Auto select first accessory if click gift item.
         */
        if (type === 'gift') {
          if (inModal) {
            return;
          }
          accessoryElement = self.querySelector('.accessories-modal-content li[data-type=gift_with_product]');
        }
        const { productContentUrl: url, productId } = accessoryElement.dataset;

        if (type == 'gift_with_product' || type == 'gift') {
          self.displayItemAccessory(productId, url, true);
        } else {
          self.displayItemAccessory(productId, url, false, oneline);
        }

        /**
         * Auto scroll to center if click item not in modal.
         */
        if (!inModal) {
          self.querySelector(`.accessories-modal-content li[data-product-id="${productId}"]`).scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });
        }
      },
      '.add-button',
      '.selected-button'
    );

    window.UniEventBus.on('SELECT_ACCESSORY_ITEM', (item) => {
      /**
       * item: {
       *  productId
       *  variantId
       *  productHandle
       * }
       */
      const { productId, productHandle, variantId, variantPrice, sku } = item;
      this.selectItem(productId, productHandle, variantId, variantPrice, sku);
    });

    window.UniEventBus.on('REMOVE_ACCESSORY_ITEM', (item) => {
      /**
       * item: {
       *  productId
       * }
       */
      const { productId } = item;
      this.removeItem(productId);
    });

    // 判断配件是否适用于目前所选择的桌子sku，会在桌子sku变化时触发
    window.UniEventBus.on('UPDATE_FIT_STATUS', (data) => {
      const currentDeskSku = data.sku;
      const listItems = this.querySelectorAll('.accessories-list li[data-type=accessory]');
      for (const item of listItems) {
        const { productId } = item.dataset;
        const variantsData = document.querySelector(`#accessory-variants-data-${productId}`);
        if (variantsData) {
          const variants = JSON.parse(variantsData.innerHTML);

          // 如果配件没有任何一个sku适用于当前桌子sku，则不可选
          if (
            variants.every((variant) =>
              window.unfit_accessories_data.some(
                (dataItem) => dataItem.accessories_sku.includes(variant.sku) && dataItem.desks_sku.includes(currentDeskSku)
              )
            )
          ) {
            item.classList.add('unfit');
          } else {
            item.classList.remove('unfit');
          }
        }
      }
    });

    window.UniEventBus.registerProvider('SELECTED_ACCESSORIES', () => this.selectedAccessories);
  }

  disconnectedCallback() {
    console.log('disconnectedCallback');
  }

  /**
   * Hide header when modal opened
   */
  observerModal() {
    let needReveal = false;

    const observer = new MutationObserver((mutationsList, observer) => {
      debugger;
      const opened = mutationsList[0].target.hasAttribute('open');
      if (opened) {
        document.querySelector('.product__info-container--sticky').style.zIndex = 102;
        if (document.querySelector('.shopify-section-header-sticky:not(.shopify-section-header-hidden)')) {
          document.querySelector('sticky-header').hide();
          needReveal = true;
        }
      } else {
        document.querySelector('.product__info-container--sticky').style.zIndex = 1;
        if (needReveal) {
          document.querySelector('sticky-header').reveal();
          needReveal = false;
        }
      }
    });
    observer.observe(this.modal, { attributes: true });
  }

  /**
   * Switch to some accessory
   * @param {string} url accessory product url
   */
  displayItemAccessory(productId, url, isGift = false, oneline = false) {
    if (isGift) {
      this.contentNode.classList.add('isGift');
    } else {
      this.contentNode.classList.remove('isGift');
    }

    if (oneline) {
      this.contentNode.classList.add('oneline');
    } else {
      this.contentNode.classList.remove('oneline');
    }

    this.modal.show();

    if (this.lastFetchTask) {
      // cancel last fetch task
      this.lastFetchTask.abort();
    }

    // change list item checked style
    this.querySelectorAll('.accessories-modal-content .accessories-list li').forEach((el) => el.classList.remove('checked'));
    this.querySelector(`.accessories-modal-content .accessories-list li[data-product-id="${productId}"]`).classList.add('checked');

    this.loadingBar.style.display = 'block';
    this.contentNode.innerHTML = '';

    this.lastFetchTask = new AbortController();
    const { signal } = this.lastFetchTask;

    fetch(url, { signal })
      .then((r) => r.text())
      .then((res) => {
        // delete last fetch task
        this.lastFetchTask = null;
        this.loadingBar.style.display = 'none';
        this.contentNode.innerHTML = res;
      })
      .catch((e) => {
        if (e.name === 'AbortError') {
          console.warn('fetch canceled');
        }
      });
  }
}

customElements.define('accessories-sales', AccessoriesSales);
